<buttons-wrapper>
  <button mat-flat-button type="button" mat-dialog-close>{{ 'CANCEL' | translate }}</button>
  <button [disabled]="submitDisabled" mat-flat-button color="primary" type="submit">{{ (submitLabel || 'SAVE') | translate }}</button>
</buttons-wrapper>

